import PortalIdParser from 'PortalIdParser';
export const CREATE_DASHBOARD_LINK = `/discover/${PortalIdParser.get()}/create/dashboards`;
export const GROSS_PAYMENT_DASHBOARD_LINK = `/reports-dashboard/${PortalIdParser.get()}/view/`;
export const COMMERCE_HUB_LINK = `/commerce/${PortalIdParser.get()}`;